import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "bootstrap";
import Autocomplete from "react-google-autocomplete";

import { apiData } from "../../../actions";
import { UsePlaceAuth } from "../../../AppContext/AppContext";
import { setPlace } from "../../../Redux/Action/Action";
import sportsticketsbg from '../../../assets/images/sports-tickets-bg.png'
import popup from '../../../assets/images/popup-bg.png'
import popup3 from '../../../assets/images/popup3-images.png'

import "swiper/css";
import "swiper/css/navigation";

const sportsImages = {
  MLB: "mlb.png",
  NBA: "nba.png",
  NFL: "nfl.png",
  NHL: "nhl.png",
  MLS: "mls.png",
  CFL: "cfl.png",
};

export default function HomeSportsTickets() {
  const place = useSelector((state) => state.place);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setSportsKeyword, setGameCatagory } = UsePlaceAuth();

  const [sportsFontAll, setSportsFontAll] = useState(null);

  /* ---------------- GET SPORTS DATA ---------------- */
  const getTickets = async () => {
    try {
      const payload = { city: place };
      const res = await apiData.Sports_Tickets_Things_To_Do(payload);

      if (res?.status >= 200 && res?.data?.data?.length) {
        setSportsFontAll(res.data.data[0]);
      }
    } catch (err) {
      console.log("Sports API error:", err);
    }
  };

  useEffect(() => {
    getTickets();
  }, [place]);

  const handleSportClick = (league) => {
    const cleanLeague = league.normalize("NFKD").replace(/[^\w]/g, "");

    setSportsKeyword(cleanLeague);
    setGameCatagory?.(cleanLeague);

    if (!place) {
      const modalEl = document.getElementById("sportsLocationModal");
      const modalInstance =
        Modal.getInstance(modalEl) || new Modal(modalEl);
      modalInstance.show();
    } else {
      navigate(`/sports/${place}`);
    }
  };

  return (
    <>
      {/* ---------------- SPORTS SECTION ---------------- */}
      <section
        className="section-equal-padding find-car-sec"
        style={{
          backgroundImage: `url(${sportsticketsbg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        }}
      >
        <div className="container-fluid">
          <div className="row align-items-center sports_tickets_icon">
            <div className="col-md-12 col-xl-4 col-xxl-3">
              <div className="section-top-heading mb-3 mb-md-5">
                <h2 className="text-white">Sports Tickets</h2>
                <p className="text-white">Enjoy the local pass time</p>
              </div>
            </div>

            <div className="col-md-12 col-xl-8 col-xxl-9">
              {sportsFontAll ? (
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  loop
                  autoplay={{ delay: 3000 }}
                  navigation
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 },
                    1440: { slidesPerView: 4},
                  }}
                  className="excitement-swiper sports"
                >
                  {Object.keys(sportsFontAll).map((league) => (
                    <SwiperSlide key={league}>
                      <div
                        className="special-card-box"
                        onClick={() => handleSportClick(league)}
                      >
                        <figure>
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/${sportsImages[league]}`}
                            alt={league}
                          />
                        </figure>
                        <div className="specialCard-content">
                          <p className="sports_">
                            {league} <i className="fa-solid fa-arrow-right"></i>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <p className="text-white">Loading sports...</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- SPORTS MODAL ---------------- */}
      <div
        className="modal fade modal_bg_change"
        id="sportsLocationModal"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered sports_tickets_popup">
          <div
            className="modal-content"
            style={{
              backgroundImage: `url(${popup})`,
              backgroundSize: "cover",
            }}
          >
            <button
              className="btn-close sports_tickets_close"
              data-bs-dismiss="modal"
            ></button>

            <div className="modal-body">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <h2 className="text-white">Sports Tickets</h2>
                  <p className="text-white">Enjoy the local pass time</p>

                  <div className="popup_search">
                    <Autocomplete
                      className="form-control"
                      apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                      placeholder="Where would you like to go"
                      onPlaceSelected={(city) => {
                        const selectedCity =
                          city.formatted_address.split(",")[0].toLowerCase();

                        const modal =
                          Modal.getInstance(
                            document.getElementById("sportsLocationModal")
                          );
                        modal?.hide();

                        dispatch(setPlace(selectedCity));
                        navigate(`/sports/${selectedCity}`);
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 offset-md-2">
                  <img
                    src={popup3}
                    alt="sports"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
